import { render, staticRenderFns } from "./MappedImage.vue?vue&type=template&id=062e6298&scoped=true"
import script from "./MappedImage.vue?vue&type=script&lang=js"
export * from "./MappedImage.vue?vue&type=script&lang=js"
import style0 from "./MappedImage.vue?vue&type=style&index=0&id=062e6298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e6298",
  null
  
)

export default component.exports